import { KeyboardArrowDown as KeyboardArrowDownIcon } from '@mui/icons-material';

const KeyboardArrowDown = (): JSX.Element => <KeyboardArrowDownIcon fontSize="inherit" />;

export default KeyboardArrowDown;
